import React from "react";
import "./FutureCareerCard.css";

const FutureCareerCard = ({
  name,
  futureCareer,
  personality,
  strengths = [],
  badges = [],
  recommendedCourse,
}) => {
  return (
    <div className="futurecard-wrapper">
      <div className="futurecard">
        {/* Header */}
        <div className="futurecard-header">
          <span className="futurecard-title">FUTURE CAREER BADGE</span>
        </div>

        {/* Profile Section */}
        <div className="futurecard-profile">
          <div className="futurecard-photo">
            <span className="photo-placeholder">👤</span>
          </div>
          <h2 className="futurecard-name">{name}</h2>
          <h3 className="futurecard-career">
            <span className="highlight">{futureCareer}</span>
          </h3>
        </div>

        <div className="separator"></div>

        {/* Personality Section */}
        <div className="futurecard-section">
          <h4 className="section-title">Personality Snapshot</h4>
          <div className="personality-item">
            <strong>Type:</strong> {personality}
          </div>

          {strengths.length > 0 && (
            <div className="personality-item">
              <strong>Strengths:</strong>{" "}
              {strengths.map((s) => (
                <span key={s} className="strength-chip">{s}</span>
              ))}
            </div>
          )}
        </div>

        {/* Badges */}
        {badges.length > 0 && (
          <div className="futurecard-section">
            <h4 className="section-title">Badges Earned</h4>
            <div className="badge-list">
              {badges.map((b) => (
                <span key={b} className="badge-chip">
                  {b}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Course Recommendation */}
        {recommendedCourse && (
          <div className="futurecard-section">
            <h4 className="section-title">Recommended Course</h4>
            <div className="course-box">{recommendedCourse}</div>
          </div>
        )}

        {/* Footer */}
        <div className="futurecard-footer">
          <div>Identified by Semicolon Innovations</div>
          <div className="footer-sub">AI Personality Checker</div>
        </div>
      </div>
    </div>
  );
};

export default FutureCareerCard;
